/**
 * Checks if a file should be allowed (not hidden or is .bindings)
 * @param {string} fileName - The file name to check
 * @returns {boolean} - true if file should be allowed
 */
export const isFileAllowed = fileName => {
    return fileName[0] !== "." || fileName === ".bindings";
};

/**
 * Validates if a file can be uploaded based on system rules
 * @param {File} file - The file object to validate
 * @returns {Object} - { valid: boolean, message: string | null }
 */
export const validateFileUpload = file => {
    if (!isFileAllowed(file.name)) {
        return {
            valid: false,
            message: "Hidden files cannot be uploaded, except for .bindings files, which are essential for MQ adapters."
        };
    }

    return { valid: true, message: null };
};
